<template>
  <v-footer
    padless
  >
    <v-card
      flat
      tile
      width="100%"
      color="primary"
      class="lighten-1 white--text text-center"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          :class="{'white--text': whiteText}"
          class="mx-4"
          icon
        >
          <v-icon size="24px">
            {{ icon }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text 
        :class="{'white--text': whiteText}"
        class=" pt-0"
      >
        <slot name="infos">
          If you're doing something when you've got to change subject, stop doing it
        </slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        <slot name="copyright">
          2021 — <strong>Likablehair</strong>
        </slot>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import {
  VFooter,
  VCard,
  VCardText,
  VBtn,
  VIcon,
  VDivider
} from 'vuetify/lib'

export default {
  name: "StandardFooter",
  components: {
    VFooter,
    VCard,
    VCardText,
    VBtn,
    VIcon,
    VDivider
  },
  data: function() {
    return {
    }
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    icons: {
      type: Array,
      default: function() {
        return [
          'mdi-linkedin',
          'mdi-instagram',
        ]
      }
    },
    whiteText: {
      type: Boolean,
      default: true,
    }
  }
}
</script>

<style>

</style>